import { Box, CircularProgress } from '@mui/material'
import AdxEmptyState from 'components/reusable/emptyState/AdxEmptyState'
import PersonalityCard from './PersonalityCard'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const PersonalityDrawer = ({ id, error, isLoading }) => {
  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          width: '100%',
          height: 200,
        }}
      >
        <CircularProgress color="alternate" />
      </Box>
    )
  } else if (error !== null) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          width: '100%',
          height: 200,
          overflow: 'hidden',
        }}
        borderTop={1}
        borderColor={'gray-line.main'}
      >
        <AdxEmptyStateV2 icon="stars_rounded_outlined" />
      </Box>
    )
  } else {
    return (
      <Box>
        <PersonalityCard id={id} />
      </Box>
    )
  }
}
export default PersonalityDrawer
